import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import memoizeOne from 'memoize-one';
import { ClearIndicator } from './ClearIndicator';
import { MultiValue } from './MultiValue';
import { MultiValueContainer } from './MultiValueContainer';
import { Option } from './Option';
import { SingleValue } from './SingleValue';
import { Input } from './Input';
import { SingleValueContainer } from './SingleValueContainer';
import { PopupInput } from './PopupInput';
import { PopupControl } from './PopupControl';
/**
 * Memoize getComponents to avoid rerenders.
 */

export var getComponents = memoizeOne(function (multi, anchor) {
  if (anchor) {
    return {
      Control: anchor,
      Option: Option
    };
  } else {
    return {
      MultiValue: MultiValue,
      DropdownIndicator: null,
      SingleValue: SingleValue,
      ClearIndicator: multi ? null : ClearIndicator,
      Option: Option,
      ValueContainer: multi ? MultiValueContainer : SingleValueContainer,
      Input: Input
    };
  }
});
export var getPopupComponents = memoizeOne(function (hasPopupTitle) {
  var baseProps = {
    DropdownIndicator: null,
    SingleValue: SingleValue,
    ClearIndicator: ClearIndicator,
    Option: Option,
    ValueContainer: SingleValueContainer,
    Input: PopupInput
  };

  if (hasPopupTitle) {
    return _objectSpread(_objectSpread({}, baseProps), {}, {
      Control: PopupControl
    });
  }

  return baseProps;
});